// Etiqueta "veículo com assistência" (pedido 2026-10-16): mesma aparência em
// Editar Cliente → VEÍCULOS, Faturamento, Contrato e no menu Assistência.
import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

export function AssistancePlanBadge({ plan, group, className }: { plan?: string | null; group?: string | null; className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[11px] font-bold text-emerald-700 dark:text-emerald-300",
        className,
      )}
      title={group ? `Assistência: ${group}` : "Veículo com assistência"}
    >
      <ShieldCheck className="h-3 w-3" />
      {plan || "Com assistência"}
      {group && <span className="font-medium opacity-80">· {group}</span>}
    </span>
  );
}
